import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-300">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-white text-lg"></i>
              </div>
              <span className="font-bold text-xl text-white">草民影院</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              免费高清影视在线观看平台，每日更新海量热门电影、电视剧、综艺、动漫、纪录片。无需付费，畅享视听盛宴。
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold text-white mb-4">
              <a href="#footer-nav" className="text-white no-underline">快速导航</a>
            </h4>
            <div id="footer-nav" className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">首页</Link>
              {categories.filter(c => c.slug !== 'all').map(cat => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          {/* About */}
          <div>
            <h4 className="font-semibold text-white mb-4">
              <a href="#footer-about" className="text-white no-underline">关于我们</a>
            </h4>
            <div id="footer-about" className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">品牌介绍</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">服务条款</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">隐私政策</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">免责声明</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white mb-4">
              <a href="#footer-contact" className="text-white no-underline">联系我们</a>
            </h4>
            <div id="footer-contact" className="flex flex-col gap-2 text-sm text-foreground-400">
              <div className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@caominyingyuan.com</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-customer-service-line"></i>
                <span>在线客服：7x24小时</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>中国 · 北京</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 草民影院 CaominYingYuan.com 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            本站所有资源均来自互联网，仅供交流学习使用
          </p>
        </div>
      </div>
    </footer>
  );
}